import React from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";

const EPCLink = ({epc = ''}) => {

  return (<Link to={"/track/" + epc.value} title={epc.value}>
    {/* Se necessario tambem podemos usar algo assim: https://codepen.io/markchitty/pen/RNZbRE */}
    {epc.value}
  </Link>)
};

EPCLink.propTypes = {
  epc: PropTypes.object
};

export default EPCLink;



// WEBPACK FOOTER //
// ./src/component/Asset/EPCLink.js